import { IFlyingCart } from "@features/cart/IFlyingCart";
import { useStyle } from "../FlyingCartLayouts/style";
import { FlyingCartItem } from "./FlyingCartItem/FlyingCartItem";

interface IParams {
    arePricesLoading?: boolean;
    flyingCart: IFlyingCart;
}

export const FlyingCartItems = (props: IParams) => {
    const { flyingCart, arePricesLoading } = props;
    const { classes } = useStyle({});

    return (
        <div className={classes.flyingCartItems}>
            {flyingCart.offers
                .flatMap((offer) => offer.cartItems)
                .map((cartItem, index) => (
                    <FlyingCartItem
                        arePricesLoading={arePricesLoading}
                        description={cartItem.description}
                        key={`cart-item-${index}`}
                        monthlyAmount={cartItem.monthlyAmount}
                        quantity={cartItem.quantity}
                        upfrontAmount={cartItem.upFrontAmount}
                    />
                ))}
        </div>
    );
};
